import * as React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsExporting from 'highcharts/modules/exporting';
import { useSelector } from 'react-redux';
import { ReduxStates } from '../redux/reduxTypes';

// extends export functionality to the main highcharts library
if (typeof Highcharts === 'object') {
  HighchartsExporting(Highcharts);
}

export interface Props {
  lineGraphEl: any;
  graphOptions?: Highcharts.Options | null;
  containerStyle?: any;
}

const HighchartsWrapper = ({ containerStyle, graphOptions, lineGraphEl }: Props): React.ReactElement => {
  const copyData = useSelector((state: ReduxStates) => state.copyData);

  return (
    <>
      {graphOptions && (
        <HighchartsReact
          containerProps={{ style: containerStyle }}
          ref={lineGraphEl}
          highcharts={Highcharts}
          options={graphOptions}
        />
      )}
      {!graphOptions && (
        <div className="w-full h-full min-h-[200px] flex items-center justify-center">
          <p className="font-nunitoBold text-filterList text-base">{copyData?.no_data}</p>
        </div>
      )}
    </>
  );
};

export default HighchartsWrapper;
